import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18n from 'i18next';
import querystring from 'query-string';
import { css } from '@emotion/core';
import Divider from '@material-ui/core/Divider';

import { IS_UGC_FLOW } from 'config/envVariable';
import { line, system300 } from 'Mui/styles/color';
import { getLiffUrl } from 'client/utils/login';
import { retrieveLineConfig } from 'utils/manipulatePartnerSponsor';
import { getQsOfParentUrl } from 'client/utils/queryString';

import useLoginLinkClickAction from 'client/hooks/login/useLoginLinkAction';

import Button from 'Mui/Button';
import LineLiffQrCode from 'client/components/dialogLogin/LineLiffQrCode';
import LoginLine from './LoginLine';

function LoginLineLiff({ type, isPC = false }) {
    const { promoUUID } = useParams();
    const partner = useSelector(s => s.partner);
    const sponsor = useSelector(s => s.sponsor);
    const sponsorUUID = useSelector(s => s.sponsor.uuid);
    const { lineLoginAppLiffId } = retrieveLineConfig({ partner, sponsor });

    const liffId = lineLoginAppLiffId;

    const baseOnPromotionsRouteRedirectPath = `/r/promotions/p/${promoUUID}`;
    const baseOnUgcRouteRedirectPath = window.location.pathname;
    const redirectPath = IS_UGC_FLOW
        ? baseOnUgcRouteRedirectPath
        : baseOnPromotionsRouteRedirectPath;
    const appendQsObj = (() => {
        let { parentUrl, ...qsObj } = querystring.parse(window.location.search);
        const parentQuery = getQsOfParentUrl(parentUrl);
        qsObj = { ...qsObj, ...parentQuery, promo_uuid: promoUUID };

        return qsObj;
    })();
    const liffUrl = getLiffUrl({
        liffId,
        sponsorUUID,
        redirectPath,
        appendQsObj
    });

    return type === types.QRCODE ? (
        <div css={contentStyle}>
            <LineLiffQrCode url={liffUrl} />
            {isPC && (
                <div css={css(lineLoginWrapperStyle)}>
                    <LoginLine />
                </div>
            )}
        </div>
    ) : (
        <LoginLineButton url={liffUrl} />
    );
}

export default LoginLineLiff;

function LoginLineButton({ url }) {
    const { target } = useLoginLinkClickAction({ loginUrl: url });

    return (
        <a href={url} target={target} css={linkStyle}>
            <Button css={buttonStyle}>
                <span css={iconStyle} />
                <Divider css={dividerStyle} orientation="vertical" flexItem />
                {i18n.t('label.login.open_line_liff')}
            </Button>
        </a>
    );
}

export const types = {
    BUTTON: 'button',
    QRCODE: 'qrCode'
};

const buttonStyle = css`
    color: #fff;
    border-radius: 8px;
    background-color: ${line.color};
    padding: 6px 6.5px;
    font-weight: bold;
    padding-left: 5px;
    display: flex;
    flex-direction: column;
    &:hover {
        background-color: ${line.color};
    }
    &.Mui-disabled {
        background-color: ${system300.color};
        color: #fff;
    }
`;

const lineLoginWrapperStyle = css`
    padding-top: 1rem;
`;

const linkStyle = css`
    text-decoration: none;
`;

const iconStyle = css`
    height: 24px;
    width: 24px;
    display: block;
    background: url(https://assets.fevercdn.com/promotion/img/icon-line-login.png) 50% 50% no-repeat;
    background-size: contain;
`;

const dividerStyle = css`
    margin: -6px 5px;
`;

const contentStyle = css`
    display: flex;
    flex-direction: column;
`;
